import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { type CaixaLotteryType, calculateCost, CAIXA_LOTTERIES } from "@/utils/caixa";
import { type SubscriptionPlan } from "@/utils/predictionUtils";

interface CostCalculatorProps {
  lotteryType: CaixaLotteryType;
  gamesCount: number;
  userPlan: SubscriptionPlan;
}

const CostCalculator: React.FC<CostCalculatorProps> = ({ 
  lotteryType, 
  gamesCount,
  userPlan
}) => {
  const lottery = CAIXA_LOTTERIES[lotteryType];
  const totalCost = calculateCost(lotteryType, gamesCount);

  return (
    <Card className="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-950/20 dark:to-emerald-950/20 border-green-200 dark:border-green-700">
      <CardContent className="p-4">
        <div className="text-center space-y-2">
          <h4 className="font-bold text-green-700 dark:text-green-300">
            💰 Cálculo do Investimento
          </h4>
          
          <div className="grid grid-cols-3 gap-4 text-sm">
            <div className="bg-white dark:bg-gray-800 p-2 rounded border">
              <div className="font-medium text-green-600">Valor Unitário</div>
              <div className="text-lg font-bold">R$ {lottery.price.toFixed(2)}</div>
            </div>
            <div className="bg-white dark:bg-gray-800 p-2 rounded border">
              <div className="font-medium text-green-600">Jogos</div>
              <div className="text-lg font-bold">{gamesCount}</div>
            </div>
            <div className="bg-white dark:bg-gray-800 p-2 rounded border">
              <div className="font-medium text-green-600">Total</div>
              <div className="text-lg font-bold">R$ {totalCost.toFixed(2)}</div>
            </div>
          </div>
          
          <p className="text-xs text-green-600 dark:text-green-400">
            💡 Investimento calculado automaticamente
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default CostCalculator;
